import { useEffect, useState } from "react";
import IDynamicFormRow from "../../../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import { FormPasswordInput } from "../../../yoello-lib/modules/dynamicForms/FormComponents/FormPasswordInput";
import { useTranslation } from "react-i18next";
import {
  defaultPasswordRegex as passwordRegex,
  sixDigitNumberCodeRegex,
} from "../../../yoello-lib/modules/dynamicForms/ValidationUtils";
import { VerificationInput } from "../../../yoello-lib/modules/dynamicForms/FormComponents/FormEmailVerificationCodeInpt";
import ResendCodeText from "../util/ResendCodeText";

export function useGenerateResetPasswordForm () {
  const [formRows, setFormRows] = useState<IDynamicFormRow[]>();
  const [oneTimeCode, setOneTimeCode] = useState("");
  const { t } = useTranslation();

  const generatePasswordResetFormRows = () => {
    const defaultFormElement: Partial<IDynamicFormRow> = {
      inputProperties: {
        variant: "outlined",
      },
      gridColumnOptions: { formCol: 12 },
      registerOptions: {
        required: true,
      },
    };

    const formRows:IDynamicFormRow[] =  [
      {
        ...defaultFormElement,
        keyName: "code",
        Component: VerificationInput,
        registerOptions: {
          validate: (data: any) =>
            oneTimeCode.toString().trim().match(sixDigitNumberCodeRegex)
              ? true
              : t("forms.forgotPassword.Errors.codeValidationError") as string,
        },
        formProps: {
          onChange: changeOneTimeCode,
          value: oneTimeCode,
        },
        label: t("forms.forgotPassword.Texts.validationCode"),
      },
      { label: "", Component: ResendCodeText, keyName: "resendCode" },
      {
        ...defaultFormElement,
        keyName: "password",
        Component: FormPasswordInput,
        registerOptions: {
          required: true,
          validate: (data: any) =>
            data && data.trim().match(passwordRegex)
              ? true
              : t("forms.forgotPassword.Errors.passwordValidationError") as string,
        },
        label: t("forms.forgotPassword.Texts.newPassword"),
      },
      {
        ...defaultFormElement,
        keyName: "confirmPassword",
        Component: FormPasswordInput,
        registerOptions: {
          required: true,
          validate: (data: any) =>
            data && data.trim().match(passwordRegex)
              ? true
              : t("forms.forgotPassword.Errors.passwordValidationError") as string,
        },
        label: t("forms.forgotPassword.Texts.confirmPassword"),
      }
    ];
   return formRows;
  };
  function changeOneTimeCode(otp: string) {
    setOneTimeCode(otp);
  }

  useEffect(() => {
    setFormRows(generatePasswordResetFormRows());
    // eslint-disable-next-line
  }, [oneTimeCode]);

  return { formRows, oneTimeCode };
};

